import { StyleSheet } from 'react-native';
import ObjectEmployee from 'utils/objects/employee'
import _ from 'lodash'
import i18n from 'utils/i18n'
import React from 'react'
import DataItem from 'components/atoms/DataItem'
import { useIsInManagement } from 'utils/helper-linking'
import { IconTimeslotConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'
import { DataItemStyles } from 'styles/components/atoms/DataItem'
import Text from 'theme/Text'
import HStack from 'components/atoms/stack/HStack'
import VStack from 'components/atoms/stack/VStack'

export const EmployeeParkingScans = ( { items = {} } ) => {
	const isInManagement = useIsInManagement()
	
	// Only show this on web
	if( !isInManagement ) {
		return null;
	}
	
	const employee = ObjectEmployee.getLoggedIn();
	
	// Only show this for admins
	if( !ObjectEmployee.isAdmin( employee ) ) {
		return null;
	}
	
	let content = i18n.t('management:generic.parking_scan.not_scanned_in');
	let renderedItems = null;
	if( _.size( items ) > 0 ) {
		
		content = null;
		let rows = [];
		_.forEach( items, ( item, key ) => {
			
			const direction = _.get( item, 'status', 'scanned_in' ) == 'scanned_in' ? 'in' : 'out';
			
			let time = ''
			const scannedAt = _.get( item, 'scanned_at', null );
			if( scannedAt !== null ) {
				time = scannedAt.substr( 11, 5 );
			}
			
			let identifier = '';
			const scannedCode = _.get( item, 'scanned_code', null );
			if( scannedCode !== null ) {
				identifier = scannedCode.replace( 'license_plate:', '' );
			}
			
			rows.push(
				<HStack>
					<Text style={ staticStyles.textFontSize11 }>{ time }</Text>
					<Text style={ staticStyles.textFontSize11 }>{direction}</Text>
					<Text style={ staticStyles.textFontSize11 }>{identifier}</Text>
				</HStack>
			)
		});
		
		renderedItems = (
			<VStack
				style={staticStyles.vStackWidth100}>
				{ rows }
			</VStack>
		);
		
	}
	return (
		<DataItem
			icon={ <Icon icon={ IconTimeslotConstants.CAR } style={ [ DataItemStyles.headerIcon ] } /> }
			content={ content }
			items={ renderedItems}>
			
			{ i18n.t('constants.parking_scan_status') }
		</DataItem>
	)
}


const staticStyles = StyleSheet.create({
	textFontSize11: {
		fontSize: 11,
	},
	vStackWidth100: {
		width: '100%',
	},
});
